import { MediaLibPresetEnum } from "../../types";

export const MEDIA_DIALOG_HEADER = {
  [MediaLibPresetEnum.OnlyImages]: {
    title: "Add an image",
    icon: "ri-image-line",
  },
  [MediaLibPresetEnum.OnlyVideos]: {
    title: "Add a video",
    icon: "ri-video-on-line",
  },
  [MediaLibPresetEnum.All]: {
    title: "Add a media",
    icon: "ri-image-line",
  },
};
